import {servicioRestfulCompleto, servidor} from "../../Configuracion";
import ClienteRestful from "../../../framework2/ej2/network/ClienteRestful";

export const CONFIGURACION_CHANGED = 'CONFIGURACION_CHANGED';


export const loadConfiguracion = () => {
    return (dispatch) => {
         let url= servidor + servicioRestfulCompleto + "Configuracion/1";
        const clienteRestful = new ClienteRestful().setUrl(url);
        clienteRestful.doGet( response => {
            dispatch(configuracionLoaded(response));
        });
    }
}


export const configuracionLoaded = (configuracion) => {
    return {
        type: CONFIGURACION_CHANGED,
        state: configuracion
    }
}